import React, { useState, useEffect } from "react";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { logoutUser } from "../../redux/actions/authActions";
import { useSelector, useDispatch } from "react-redux";

function CommonLogout() {
  const dispatch = useDispatch();
  const partnerloginUser = useSelector(({ login }) => login);
  const regenerateTokenRes = useSelector(
    ({ regenerateToken }) => regenerateToken
  );
  var authToken = regenerateTokenRes.data.AuthToken;
  sessionStorage.removeItem("walletOwnerId");
  const LogoutUsertRequest = () => {
    const logoutUserReq = {
      authToken: authToken,
      authentication: {
        partnerId: regenerateTokenRes.data.partnerId || "",
      },
    };

    return dispatch(logoutUser(logoutUserReq, authToken));
  };

  useEffect(() => {
    LogoutUsertRequest();
  }, []);

  const logoutUsers = useSelector(({ logout }) => logout);
  // console.log("logoutUser" + logoutUsers);
  // console.log("logoutUser");

  const logoutUsersFunc = () => {
    if (logoutUsers.data.status == "Success") {
    }
  };

  useEffect(() => {
    if (logoutUsers.data.status == "Success") {
      logoutUsersFunc();
    }
  }, [logoutUsers.data.status]);

  return true;
}

export default CommonLogout;
